import React, { useState } from "react";
import { Redirect } from "react-router";
import styled from "styled-components";

import UIManager from "../../service/ui-manager";
import { showDevModal } from "./actions";

import { Text, Col } from "../../comps";
import { NAVBAR } from "../../theme/dimensions";
import { COLORSCHEME } from "../../theme/color";
import { NAV_OPTIONS } from "../../constants";
import { Theme } from "../../theme/theme-provider";

import {
  playerBlue,
  playerGray,
  playlistBlue,
  playlistGray,
  serverBlue,
  serverGray,
  importGray,
  importBlue,
  profileGray,
  profileBlue,
  infoGray,
  programmerGray,
  infoBlue,
  backGray,
  backBlue,
  menuGray,
  menuBlue,
} from "../../theme/image";

const IconListWrapper = styled.div`
  height: 100%;
  width: ${({ width }) => width + "px"};
  flex-shrink: 0;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const IconWrapper = styled(Col)`
  width: 100%;
  height: ${NAVBAR.SIDE_ICON_SIZE + 40}px;
  overflow: hidden;
  align-items: center;
  justify-content: center;
  align-items: center;
  &:hover {
    cursor: pointer;
    background-color: ${COLORSCHEME.BLACK_2};
  }
`;

const AnimatedImg = styled.img`
  width: ${({ width }) => width + "px"};
  height: ${({ height }) => height + "px"};
  transition: position 1s ease;
`;

const AnimatedText = styled(Text)`
  opacity: ${({ visible }) => (visible ? 1 : 0)};
  transition: opacity 1s ease;
`;

const getNavItems = ({ navOption, setNavDetails, setRedirect, closeNav }) => {
  const closePlayer = () => {
    UIManager.collapsePlayer();
  };

  return [
    {
      id: NAV_OPTIONS.DRAWER,
      title: "Collapse",
      imgSrc: backGray,
      imgHoverSrc: backBlue,
      focus: navOption === NAV_OPTIONS.DRAWER,
      onHover: () => {
        setNavDetails({ isNavOpen: false, navOption: -1 });
      },
      onClick: () => {
        closeNav();
        closePlayer();
      },
    },
    {
      id: NAV_OPTIONS.PROFILE,
      title: "profile",
      imgSrc: profileGray,
      imgHoverSrc: profileBlue,
      focus: navOption === NAV_OPTIONS.PROFILE,
      onHover: () => {
        setNavDetails({ isNavOpen: true, navOption: NAV_OPTIONS.PROFILE });
      },
      onClick: () => {
        setRedirect("/account");
        closePlayer();
      },
    },
    {
      id: NAV_OPTIONS.PLAYER,
      title: "player",
      imgSrc: playerGray,
      imgHoverSrc: playerBlue,
      focus: navOption === NAV_OPTIONS.PLAYER,
      onClick: () => {
        UIManager.togglePlayer();
      },
      onHover: () => {
        setNavDetails({ isNavOpen: true, navOption: NAV_OPTIONS.PLAYER });
      },
    },
    {
      id: NAV_OPTIONS.LIBRARY,
      title: "playlists",
      imgSrc: playlistGray,
      imgHoverSrc: playlistBlue,
      focus: navOption === NAV_OPTIONS.LIBRARY,
      onHover: () => {
        setNavDetails({ isNavOpen: true, navOption: NAV_OPTIONS.LIBRARY });
      },
      onClick: () => {
        setRedirect("/playlists");
        closePlayer();
      },
    },
    {
      id: NAV_OPTIONS.SERVER,
      title: "rooms",
      imgSrc: serverGray,
      imgHoverSrc: serverBlue,
      focus: navOption === NAV_OPTIONS.SERVER,
      onHover: () => {
        setNavDetails({ isNavOpen: true, navOption: NAV_OPTIONS.SERVER });
      },
      onClick: () => {
        setRedirect("/rooms");
        closePlayer();
      },
    },
    {
      id: NAV_OPTIONS.IMPORT,
      title: "import",
      imgSrc: importGray,
      imgHoverSrc: importBlue,
      focus: navOption === NAV_OPTIONS.IMPORT,
      onHover: () => {
        setNavDetails({ isNavOpen: true, navOption: NAV_OPTIONS.IMPORT });
      },
      onClick: () => {
        setRedirect("/import");
        closePlayer();
      },
    },
    {
      id: NAV_OPTIONS.INFO,
      title: "more",
      imgSrc: infoGray,
      imgHoverSrc: infoBlue,
      focus: navOption === NAV_OPTIONS.INFO,
      onHover: () => {
        setNavDetails({ isNavOpen: false, navOption: -1 });
      },
      onClick: () => {
        setRedirect("/intro");
        closePlayer();
      },
    },
    {
      id: NAV_OPTIONS.DEVELOPER,
      title: "developer",
      imgSrc: programmerGray,
      imgHoverSrc: programmerGray,
      focus: navOption === NAV_OPTIONS.DEVELOPER,
      onHover: () => {
        setNavDetails({ isNavOpen: false, navOption: -1 });
      },
      onClick: () => {
        closePlayer();
        showDevModal();
      },
    },
  ];
};

const NavItemWrapper = ({
  item: { id, title, imgSrc, imgHoverSrc, focus, onClick, onHover },
  isNavOpen,
}) => {
  const [hover, setHover] = useState(false);

  const onMouseEnter = () => {
    setHover(true);
    onHover();
  };

  const onMouseLeave = () => {
    setHover(false);
  };
  return (
    <IconWrapper
      key={id}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      onClick={onClick}
    >
      <AnimatedImg
        width={NAVBAR.SIDE_ICON_SIZE}
        height={NAVBAR.SIDE_ICON_SIZE}
        src={hover || (isNavOpen && focus) ? imgHoverSrc : imgSrc}
      />
      <AnimatedText
        fontSize="12px"
        fontWeight="500"
        // color={"#6a7075"}
        color={Theme.color.BLUE_3}
        visible={hover}
      >
        {title}
      </AnimatedText>
    </IconWrapper>
  );
};

export default ({ navDetails, setNavDetails, closeNav }) => {
  const [redirect, setRedirect] = useState("");
  const { isNavOpen, navOption } = navDetails;

  const navItems = getNavItems({
    navOption,
    setNavDetails,
    setRedirect,
    closeNav,
  });

  return (
    <IconListWrapper width={NAVBAR.SIDE_WIDTH}>
      {redirect && <Redirect push to={redirect} />}
      {navItems.map((item) => {
        return <NavItemWrapper item={item} isNavOpen={isNavOpen} />;
      })}
    </IconListWrapper>
  );
};
